module.exports = __webpack_public_path__ + "static/img/3-1-create-aftersale-empty.d8c1ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-1-create-aftersale-empty.png
// module id = 1322
// module chunks = 0